module.exports = __webpack_public_path__ + "3684b66bb9c7ac52aec1bfe71c638f25.jpg";